import styled from '@emotion/styled';
import Link from 'next/link';

import { breakPoints } from 'constant/breakPoints';

export default function BannerServicesItem({
  title,
  description,
  id,
  src,
}: {
  title: string;
  description: string;
  src: string;
  id: string;
}) {
  return (
    <Wrap>
      <div>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <Des>{description}</Des>
        <Link href={`#${id}`} prefetch={false}>
          <a className="button">Read more</a>
        </Link>
      </div>
      <Image>
        <img src={src} alt={description} />
      </Image>
    </Wrap>
  );
}

const Wrap = styled.div`
  padding: 16px 16.5px;
  position: relative;
  max-width: 1150px;
  margin: 0 auto;
  height: 100%;

  .button {
    font-size: 14px;
    color: #ffffff;
    background: linear-gradient(
      188.34deg,
      #a336d9 13.45%,
      rgba(163, 54, 217, 0.6) 144.25%
    );
    border-radius: 100px;
    padding: 10px 27px;
    line-height: initial;
    transition: 0.4s ease-in-out;
    border: 2px solid transparent;

    &:hover {
      border-color: #fff;
      background: transparent;
      color: #fff;
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button {
      padding: 16px 55px;
    }
  }
`;

const Title = styled.div`
  font-size: 24px;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 24px;

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    font-weight: 500;
    font-size: 64px;
    line-height: 120%;
    margin-bottom: 16px;
  }
`;

const Des = styled.div`
  color: #d0cfd4;
  margin-bottom: 24px;

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    margin-bottom: 48px;
  }
`;

const Image = styled.div`
  width: 100%;

  img {
    display: block;
    height: 53.333vw;
    margin-right: 0;
    margin-left: auto;
    transform: translateY(-30px);
    width: auto;
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    width: 50%;
    flex: 0 0 50%;

    img {
      width: 100%;
      height: auto;
      transform: none;
    }
  }
`;
